import { render, staticRenderFns } from "./SalesVolume.vue?vue&type=template&id=4bee8331&scoped=true&"
import script from "./SalesVolume.vue?vue&type=script&lang=js&"
export * from "./SalesVolume.vue?vue&type=script&lang=js&"
import style0 from "./SalesVolume.vue?vue&type=style&index=0&id=4bee8331&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee8331",
  null
  
)

export default component.exports